<template>
    
    <v-dialog
        :value="display"
        max-width="700"
        persistent
    >
    <MessageOverlay ref="overlay"/>
        <v-card >
            <v-card-title>
                <span class="text-h5">Enter new password</span>
            </v-card-title>
            <v-card-text class="px-2 px-sm-6">
                <v-form ref="form" v-model="passwordFormValidation" lazy-validation>
                    <v-text-field
                        v-model="emailProp"
                        prepend-icon="mdi-account-circle"
                        name="E-mail"
                        label="E-mail"
                        type="text"
                        outlined
                        required
                        disabled
                    ></v-text-field>
                    <v-text-field
                        v-model="newPass.value"
                        outlined
                        required
                        :rules="newPass.rules"
                        :label="$vuetify.lang.t('$vuetify.account.newPassword.newpassword')+'*'"
                        :type="newPass.show ? 'text' : 'password'"
                        :append-icon="newPass.focus ? newPass.show ? 'mdi-eye-off' : 'mdi-eye' : undefined"
                        @click:append="newPass.show = !newPass.show"
                        @focus="newPass.focus = true"
                        @blur="newPass.focus = false"
                    ></v-text-field>
                    <v-text-field
                        v-model="confirmationPass.value"
                        outlined
                        required
                        :rules="confirmationPass.rules"
                        :label="$vuetify.lang.t('$vuetify.account.newPassword.passwordconfirmation')+'*'"
                        :type="confirmationPass.show ? 'text' : 'password'"
                        :append-icon="confirmationPass.focus ? confirmationPass.show ? 'mdi-eye-off' : 'mdi-eye' : undefined"
                        @click:append="confirmationPass.show = !confirmationPass.show"
                        @focus="confirmationPass.focus = true"
                        @blur="confirmationPass.focus = false"
                    ></v-text-field>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            :disabled="!passwordFormValidation"
                            :class="{ 'gradient-wintech': (passwordFormValidation) }"
                            @click="validatePassword"
                        >
                            <v-icon left>mdi-content-save</v-icon>
                            {{ $vuetify.lang.t('$vuetify.account.newPassword.validate') }}
                        </v-btn>
                        <v-btn
                            color="error"
                            @click="cancelNewPasswordDialog"
                        >
                            <v-icon left>mdi-cancel</v-icon>
                            {{ $vuetify.lang.t('$vuetify.account.newPassword.cancel') }}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import { sha3_512 } from 'js-sha3';
import MessageOverlay from '@/components/Overlay/MessageOverlay.vue'
export default {
    name: "NewPassword",
    components: {MessageOverlay},
    props: {
        display: Boolean,
        emailProp: String
    },
    data() {
        return {
            emailRules: [
                v => !!v || 'Email is required',
                 v => /.+@.+\..+/.test(v) || 'Email must be valid',
            ],
            newPass: {
                value: "",
                show: false,
                focus: false,
                rules: [
                    v => !!v ||  this.$vuetify.lang.t('$vuetify.account.newPassword.passwordisrequired'),
                    v => /^(?=.*[A-Z])/.test(v) || this.$vuetify.lang.t('$vuetify.account.newPassword.yourpasswordshouldcontainatleastoneuppercase'),
                    v => /^(?=.*\d)/.test(v) || this.$vuetify.lang.t('$vuetify.account.newPassword.yourpasswordshouldcontainatleastonedigit'),
                    v => /^(?=.*[a-z])/.test(v) || this.$vuetify.lang.t('$vuetify.account.newPassword.yourpasswordshouldcontainatleastonelowercase'),
                    v => /^(?=.*[!@#$%^&*])/.test(v) || this.$vuetify.lang.t('$vuetify.account.newPassword.yourpasswordmustcontainatleastonespecialcharacter'),
                    v => /^[a-zA-Z0-9!@#$%^&*]{8,}/.test(v) || this.$vuetify.lang.t('$vuetify.account.newPassword.yourpasswordshouldcontainatleast8characters'),
                ]
            },
            confirmationPass: {
                value: "",
                show: false,
                focus: false,
                rules: [
                    v => !!v ||  this.$vuetify.lang.t('$vuetify.account.newPassword.confirmationisrequired'),
                ]
            },
            passwordRules: [
                v => !!v || 'Password is required'
            ],

            showConfirmPassword: false,
            confirmPasswordFocused: false,
            passwordFormValidation: true,

        };
    },

    methods: {
        async validatePassword() {
            try {
                if (this.$refs.form.validate() && this.newPass.value === this.confirmationPass.value) {
                    const data = {
                        password: sha3_512(this.newPass.value),
                        email: this.emailProp
                    }
                    const res = await axios.post('login/newPassword', data);
                    if (res.status == 200) {
                        this.emailProp = "";
                        this.newPass = {};
                        this.confirmationPass = {};
                        this.$router.push("/login");
                        this.$emit("valid");
                    }
                } else {
                    this.showOverlay("error", this.$vuetify.lang.t('$vuetify.account.newPassword.yournewpassworddoesntmatchwithpasswordconfirmation'));
                }
            } catch(error) {
                if ('response' in error && error.response.status === 409) this.isNewEmail = false;
                else {
                    
                    this.showOverlay("error", error);
                }
            }
        },
        cancelNewPasswordDialog() {
            this.emailProp = "";
            this.newPass = {};
            this.confirmationPass = {};
            this.$router.push("/login");
            this.$emit("cancel");
        },
    },
};
</script>